import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Callout, ChoiceGroup, DefaultButton, DirectionalHint, FontWeights, Icon, mergeStyleSets, PrimaryButton, SpinnerSize, Text } from '@fluentui/react';
import { useGetPartieDiRevisionObject } from '../../../hooks/services/sPay/useOfEdPPrepare';
import { useDispatch, useSelector } from 'react-redux';
import { __MessageTypes, enum_ENUM_TIPO_RESPUESTA } from '../../../common/Dictionaries';
import CTextAreaSimple from '../../../components/Common/CTextAreaSimple';
import MainAppContext from '../../../MainAppContext';
import moment from 'moment';
import { isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';
import CValidator from '../../../components/Common/CValidator';
import { getHeaderEP, setRevisionEdP } from '../../../services/sPay/edpConfig.service';
import { t } from 'i18next';
import MessageBoxInfoComplex from '../../../components/Common/Message/MessageBoxInfoComplex';
import { action_updateEdPPrepareForceGetButtons, action_updateEdPPrepareForceGetHeader, action_updateEdPPrepareForceGetResult, action_updateEdpPrepareHeader } from '../../../reducers/actions/PAY/edpPrepareActions';
import Loading from '../../../components/Templates/Site/Loading';

const ApprovePartieDiDialog = (props) => {
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);

    const { 
        inputParam_ElementId = null,
        inputParam_EdPId = null,
        inputParam_TargetControlId = '',
        inputParam_IndexString = '',
        inputParam_CalloutVisibleIndex = null,
        inputParam_SetCalloutVisibleIndex = null,
        inputParam_DialogTitleText = '',
        inputParam_VerRevision = false,

        inputParam_RolTipoRespuestaId = null,
        inputParam_RolMatrizEtapaFlujo = null,
        inputParam_EstadoPagoPartidaId = null,
        inputParam_PartidaId = null,
        inputParam_EstadoPagoCompuestaDiId = "0",
        inputParam_Iteracion = null,
        inputParam_DisplayDirection = DirectionalHint.rightTopEdge,
        inputParam_RefreshPage = false,
        inputParam_EditMode = false,

        inputParam_EdpIatrizEtapaId = null,
        inputParam_TipoRespuestaId = null,
    } = props;

    const {
        _edpPrepareHeader: edpPrepareHeader,
    } = useSelector((state) => state.edpPreparationState);

    //const _priv_canEditEdP = (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) && !contextSite.onlyObserver;

    const callOutStyles = mergeStyleSets({
        button: {
            width: 130,
        },
        callout: {
            width: 500,
            maxWidth: '90%',
            padding: '20px 24px',
        },
        title: {
            marginBottom: 12,
            fontWeight: FontWeights.semilight,
        },
        link: {
            display: 'block',
            marginTop: 20,
        },
    });

    const options = [
        { key: 1, text: 'Sí', onRenderLabel: (option) => (<Icon styles={{root: {fontSize: "19px", top: "-3px", right: "-50px", position: "absolute", color: "green", fontWeight: "bolder"}}} iconName="ActivateOrders" />) },
        { key: 0, text: 'No', onRenderLabel: (option) => (<Icon styles={{root: {fontSize: "19px", top: "-3px", right: "-50px", position: "absolute", color: "red",   fontWeight: "bolder"}}} iconName="DeactivateOrders" />) },
    ];

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [objFormIsValid, setObjFormIsValid] = useState({
        aprobacion: true,
        comment: true,
    });

    const [labelComentarioMotivo, setLabelComentarioMotivo] = useState("Comentario / Motivo");
    const [showBtnAccept, setShowBtnAccept] = useState(true);
    const [messageAlert, setMessageAlert] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    
    const [showAceptButton, setShowAceptButton] = useState(true);
    const [actionInProgress, setActionInProgress] = useState(false);


    const [objRevision, setObjRevision] = useState({id: null, aprobado: null, observacion: null, justificacion: null});
    useGetPartieDiRevisionObject(inputParam_CalloutVisibleIndex === (inputParam_IndexString), inputParam_ElementId, inputParam_EdPId, inputParam_RolTipoRespuestaId, inputParam_PartidaId, inputParam_EstadoPagoCompuestaDiId, inputParam_Iteracion, objRevision, setObjRevision, inputParam_EdpIatrizEtapaId, inputParam_TipoRespuestaId)

    const onChangeRevisionSelectedOption = (ev, option) => {
        setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, aprobacion : true }));

        setObjRevision && setObjRevision(prevState => ({
            ...prevState,
            aprobado : (option.key === 1 ? true : false),
        }));

        Cambiar_Modo_Aprobacion_Rechazo((option.key === 1 ? true : false))
    };

    const setterApproveComment = (e) => {
        const { value } = e.currentTarget;

        if (objRevision.aprobado) {
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(value) }));
        }
        else {
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(value) }));
        }

        setObjRevision && setObjRevision(prevState => ({
            ...prevState,
            observacion: objRevision.aprobado === true ? value : null,
            justificacion: objRevision.aprobado === false ? value : null,
        }));
    }

    const validateObject = () => {
        let isValid = true;

        isValid = isValid === true ? !(objRevision.aprobado !== true && objRevision.aprobado !== false) : isValid;
        setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, aprobacion : !(objRevision.aprobado !== true && objRevision.aprobado !== false) }));

        if (objRevision.aprobado) {
            isValid = isValid === true ? !isNullUndefinedOrEmpty(objRevision.observacion) : isValid;
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(objRevision.observacion) }));
        }
        else {
            isValid = isValid === true ? !isNullUndefinedOrEmpty(objRevision.justificacion) : isValid;
            setObjFormIsValid && setObjFormIsValid(prevState => ({ ...prevState, comment : !isNullUndefinedOrEmpty(objRevision.justificacion) }));
        }

        return isValid
    }

    const prepareObjetToSave = () => {
        const objtToSave =
        {
            element_id: inputParam_ElementId,
            edp_id: inputParam_EdPId,
            partida_id: inputParam_PartidaId,
            di_id: inputParam_EstadoPagoCompuestaDiId !== "0" ? inputParam_EstadoPagoCompuestaDiId : null,
            rol: inputParam_RolTipoRespuestaId,
            aprobar: objRevision.aprobado,
            item_respuesta_interna: {
                id: 0,
                tipoRespuestaId: inputParam_RolTipoRespuestaId,
                edpMatrizEtapaId: inputParam_RolMatrizEtapaFlujo,
                estadoPagoId: inputParam_EdPId,
                observacion: objRevision.aprobado === true ? objRevision.observacion : null,
                justificacion: objRevision.aprobado === false ? objRevision.justificacion : null,
                fechaRespuesta: new Date(),
                aprobado: objRevision.aprobado,
                estadoPagoPartidaId: inputParam_EstadoPagoPartidaId,
                estadoPagoCompuestaDiId: inputParam_EstadoPagoCompuestaDiId !== "0" ? inputParam_EstadoPagoCompuestaDiId : null,
                iteracion: inputParam_Iteracion,
                fechasCicloId: 0,
                responsableLogin: null,
                codContrato: null,
                fechaRevision: null
            }
        }

        return objtToSave;
    }

    const onAprove = async () => {
        setActionInProgress(true);
        if (validateObject()) {
            const objectToSave = prepareObjetToSave()
            await setRevisionEdP(objectToSave).then(async (response) => {
                if (response.data.succeeded) {
                    if (response.data.data.result) {  
                        if (inputParam_RefreshPage) {
                            window.location.href = window.location.href
                        }
                        else {
                            dispatch(action_updateEdPPrepareForceGetHeader(true));
                            dispatch(action_updateEdPPrepareForceGetResult(true));
                            dispatch(action_updateEdPPrepareForceGetButtons(true));
                            setShowAceptButton(false);
                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                        }
                    }
                    else {
                        if (response.data.data.l_validations.length > 0) {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_validations)
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        }
                    }

                    setActionInProgress(false);
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setActionInProgress(false);
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setActionInProgress(false);
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'))
            setActionInProgress(false);
        }
    };

    const onClose = async () => {
        setShowAceptButton(true);
        inputParam_SetCalloutVisibleIndex && inputParam_SetCalloutVisibleIndex(null);
        setActionInProgress(false);
    }
    
    const Cambiar_Modo_Aprobacion_Rechazo = (objRevisionAprobado) => {
        let _message = {
            message : "",
            messageType : __MessageTypes.WARNING,
            showMessage : false,
        };

        if (objRevisionAprobado === true)
        {
            let aprobacion_inmediata = ((edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.AEC || edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.AAD || edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ATO) ? false : true);

            if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.AAD || edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ATO)
            {
                _message.message = "Al dar visto bueno a esta partida, usted afirma que le consta que los datos ingresados son fidedignos y que el pago de la partida es procedente de acuerdo a los términos del Contrato.";
                _message.showMessage = true;
            }

            if (aprobacion_inmediata)
            {
                if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.ADN)
                {
                    _message.message = "Al aprobar este Estado de Pago, usted deja constancia que el pago debe hacerse y que es consistente con los términos del Contrato.";
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA1)
                {
                    _message.message = "Al aprobar este Estado de Pago, usted deja constancia que el pago debe hacerse y que es consistente con los términos del Contrato.";
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA2)
                {
                    _message.message = "Al aprobar este Estado de Pago, usted deja constancia que el pago debe hacerse y que es consistente con los términos del Contrato.";
                    _message.showMessage = true;
                }
                else if (edpPrepareHeader.rolTipoRespuestaRevision == enum_ENUM_TIPO_RESPUESTA.RFA3)
                {
                    _message.message = "Al aprobar este Estado de Pago, usted deja constancia que el pago debe hacerse y que es consistente con los términos del Contrato.";
                    _message.showMessage = true;
                }
            }

            setLabelComentarioMotivo("Comentario");
            setShowBtnAccept(true);
        }
        else if (objRevisionAprobado === false)
        {
            setLabelComentarioMotivo("Motivo");
            setShowBtnAccept(true);
            _message.message = "";
            _message.showMessage = false;
        }
        else
        {
            setLabelComentarioMotivo("Comentario / Motivo");
            setShowBtnAccept(false);
        }

        setMessageAlert(_message)
    }

    const onDismissCallout = () => {
        setShowAceptButton(true)
        inputParam_SetCalloutVisibleIndex && inputParam_SetCalloutVisibleIndex(null)
    }

    return (
        <>
            {
                inputParam_CalloutVisibleIndex === (inputParam_IndexString) &&
                <Callout
                    className={callOutStyles.callout}
                    calloutWidth={600}
                    calloutMaxWidth={600}
                    calloutMinWidth={600}
                    calloutMaxHeight={400}
                    directionalHint={inputParam_DisplayDirection} 
                    directionalHintFixed={true}
                    direc
                    role="dialog"
                    gapSpace={0}
                    target={inputParam_TargetControlId}
                    onDismiss={onDismissCallout}
                    setInitialFocus
                    dis
                >
                    <Text as="h1" block variant="xLarge" className={callOutStyles.title}>{ inputParam_DialogTitleText }</Text>
                    <Row className='my-3'>
                        <Col className='my-auto'><b>{t('data-lang-lbl-aprovereject')}</b></Col>
                        <Col xl={8}>
                            {
                                !inputParam_VerRevision && objRevision.id !== null &&
                                <>
                                    <ChoiceGroup
                                        selectedKey={!isNullUndefined(objRevision.aprobado) ? (objRevision.aprobado ? 1 : 0) : undefined}
                                        options={options}
                                        onChange={onChangeRevisionSelectedOption}
                                        required={true}
                                        disabled={!inputParam_EditMode}
                                        styles={{
                                            flexContainer: {
                                                display: 'flex',
                                                flexDirection: 'row',
                                                gap: "100px"
                                            }
                                        }}
                                    />
                                    <CValidator isInValid={!objFormIsValid.aprobacion} />
                                </>
                            }
                            { inputParam_VerRevision === true && (objRevision.aprobado ? 'Sí' : 'No') }
                        </Col>
                    </Row>
                    <Row className='my-3'>
                        <Col><b>{labelComentarioMotivo}</b></Col>
                        <Col xl={8}>
                            <CTextAreaSimple
                                rows={10}
                                maxLength={1000}
                                showLabel={false}
                                controlValue={ (objRevision.aprobado ? objRevision.observacion : objRevision.justificacion) } 
                                textBoxName={'action'}
                                setterControlValue={setterApproveComment}
                                editMode={!inputParam_VerRevision && inputParam_EditMode}
                            />
                            {
                                !inputParam_VerRevision &&
                                <CValidator isInValid={!objFormIsValid.comment} />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} className="message-verybottom-panel-medium">
                            <MessageBoxInfoComplex
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                                inputParam_ShowClose={true}
                            />
                        </Col>
                        {
                            messageAlert.showMessage &&
                            <Col xl={12} className="message-verybottom-panel-medium">
                                <MessageBoxInfoComplex
                                    inputParam_Message={ messageAlert.message }
                                    inputParam_Display={ messageAlert.showMessage }
                                    inputParam_MessageType={ messageAlert.messageType }
                                    inputParam_SetterMessage={ null }
                                    inputParam_ShowClose={false}
                                />
                            </Col>
                        }
                    </Row>
                    {
                        !inputParam_VerRevision &&
                        <Row className='mt-3'>
                            <Col className='d-flex'>
                                {
                                    showBtnAccept && showAceptButton && inputParam_EditMode && !actionInProgress &&
                                    <PrimaryButton className='mx-1' text={t('data-lang-btn-acept')} onClick={ onAprove } />
                                }
                                {
                                    actionInProgress &&
                                    <Loading
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={true}
                                        inputParam_Text={t('data-lang-lbl-executing')}
                                        inputParam_Position="unset"
                                        inputParam_Width="20px"
                                        inputParam_Height="20px"
                                        inputParam_Vertical={false}
                                        inputParam_ColClassName="my-auto"
                                        inputParam_EjecutingTextClass={"ps-4"}
                                        inputParam_Left="87%"
                                        inputParam_Top="11px"
                                        inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                    />
                                }
                                <DefaultButton className='mx-1' text={showAceptButton  && inputParam_EditMode ? t('data-lang-btn-cancelclose') : t('data-lang-btn-close')} onClick={onClose} />
                            </Col>
                        </Row>
                    }
                </Callout>
            }
        </>
    );
};

export default ApprovePartieDiDialog;